import { useEffect, useState } from 'react'
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "@ficatranquilo/contabilidade.com-ui";
import { PublicLoading, PublicPage } from "../Common/PublicPage";

// O formulário de login é a página hospedada do Auth0: aqui só se redireciona para ela
export default function Login() {
  const { loginWithRedirect } = useAuth0()
  const [failed, setFailed] = useState(false)
  const [attempt, setAttempt] = useState(0)

  useEffect(() => {
    const abortController = new AbortController()

    void (async function () {
      try {
        await loginWithRedirect({ appState: { returnTo: "/auth/token" } })
      } catch (error) {
        console.error(error)
        setFailed(true)
      }
    })()

    return () => {
      abortController.abort()
    }
  }, [loginWithRedirect, attempt])

  function tryAgain() {
    setFailed(false)
    setAttempt((value) => value + 1)
  }

  if (failed) {
    return (
      <PublicPage
        title="Não foi possível entrar"
        description="Tente de novo. Se continuar, fale com o suporte da Contabilidade.com."
        actions={<Button $text="Tentar novamente" $variant="primary" $action={tryAgain} />}
      />
    )
  }

  return <PublicLoading text="Entrando" />
}
